import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://json-data-jubayer.herokuapp.com",
});

export default axiosInstance;
